import { render, staticRenderFns } from "./UserPaymentSelectComponent.vue?vue&type=template&id=9fafb4c8"
import script from "./UserPaymentSelectComponent.vue?vue&type=script&lang=js"
export * from "./UserPaymentSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports